import { Injectable } from "@angular/core";
import { CurrentUser } from "@model";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class CurrentUserService {
  private _currentUser$ = new BehaviorSubject<CurrentUser | null>(null);
  currentUser$ = this._currentUser$.asObservable();

  setCurrentUser(currentUser: CurrentUser): void {
    this._currentUser$.next(currentUser);
  }

  clearCurrentUser() {
    this._currentUser$.next(null);
  }
}
